import { Route } from "./router/route";

export const ROUTES = {
  HOME: new Route("/"),
  FLASH_CARDS_RANDOM: new Route("/flashcards/random"),
  FLASH_CARDS_NEWEST: new Route("/flashcards/newest"),
};
